import Colors from '@/theme/constants/Colors';
import { Box, BoxProps } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import 'react-phone-input-2/lib/material.css';

interface PhoneInputWrapperStyledProps extends BoxProps {
  required?: boolean;
}

export const PhoneInputWrapperStyled = styled(
  Box,
)<PhoneInputWrapperStyledProps>(({ theme, required = false }) => ({
  width: '100%',
  '& .react-tel-input': {
    '& .form-control': {
      width: '100%',
      color: theme.palette.text.primary,
      border: 'none',
      backgroundColor: Colors.COLOR_WHITE_2,
      height: theme.typography.pxToRem(45),
      paddingLeft: theme.spacing(10),
      paddingTop: theme.spacing(4),
      borderRadius: theme.spacing(1),
    },
    '& .selected-flag': {
      width: theme.typography.pxToRem(72),
      backgroundColor: `${alpha(theme.palette.dark.dark_4, 0.24)} !important`,
    },
    '& .special-label': {
      top: 3,
      left: 77,
      background: 'none',
      color: theme.palette.dark.dark_4,
    },
    '& .special-label::after': {
      content: required ? "'*'" : "''",
      color: theme.palette.error.main,
      fontSize: theme.spacing(2),
      marginLeft: theme.spacing(0.4),
    },
    '& .arrow': {
      borderTop: `5px solid ${theme.palette.white.main} !important`,
      borderLeft: '5px solid transparent !important',
      borderRight: '5px solid transparent !important',
    },
    '& .country-list': {
      backgroundColor: theme.palette.dark.dark_6,
      '& .country': {
        backgroundColor: theme.palette.dark.dark_6,
      },
      '& .country.highlight': {
        color: theme.palette.primary.main,
      },
    },
  },
}));
